import { ConversationsAction } from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import { Dispatch } from "react";
import { ResultRecord, StringUtils } from "@rsm-hcd/javascript-core";
import { MemoryStatus } from "models/enumerations/conversations/memory-status";
import MemoriesService from "utilities/services/memories/memories-service";

export interface UpdateMemoryStatusParams {
    messageId?: string;
    memoryId?: string;
    status: MemoryStatus;
}

export const updateMemoryStatus =
    ({ messageId, memoryId, status }: UpdateMemoryStatusParams) =>
    async (dispatch: Dispatch<ConversationsAction>) => {
        let result: ResultRecord<boolean> | undefined;

        try {
            if (
                StringUtils.isEmpty(messageId) ||
                StringUtils.isEmpty(memoryId)
            ) {
                dispatch({
                    type: "ERROR",
                    error: new Error(
                        "Message ID and Memory ID are required to update a memory."
                    ),
                });
                return;
            }

            await MemoriesService.patch({ id: memoryId! }, { status });

            dispatch({
                type: "UPDATE_MEMORY_STATUS",
                messageId: messageId!,
                memoryId: memoryId!,
                status,
            });

            return;
        } catch (error) {
            result = new ResultRecord<boolean>().addError("ERROR", `${error}`);

            dispatch({
                type: "ERROR",
                error: new Error(
                    (
                        result?.listErrorMessages() || [
                            "Failed to update memory",
                        ]
                    ).join(", ")
                ),
            });

            return;
        }
    };
